import { createSelector } from 'reselect';

const selectOrganizations = (state: any) => state.organizations;


export const selectOrganizationsCurrentItem = createSelector([selectOrganizations], (organizations) => organizations.current);

export const selectOrganizationsListItems = createSelector([selectOrganizations], (organizations) => organizations.list);

export const selectOrganizationsItemById = (itemId: any) =>
    createSelector(selectOrganizationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectOrganizationsQueryItems = createSelector([selectOrganizations], (organizations) => organizations.query);

export const selectOrganizationsCreatedItem = createSelector([selectOrganizations], (organizations) => organizations.create);

export const selectOrganizationsUpdatedItem = createSelector([selectOrganizations], (organizations) => organizations.update);

export const selectOrganizationsReadItem = createSelector([selectOrganizations], (organizations) => organizations.read);

export const selectOrganizationsDeletedItem = createSelector([selectOrganizations], (organizations) => organizations.delete);

export const selectOrganizationsSearchedItems = createSelector([selectOrganizations], (organizations) => organizations.search);

export const selectOrganizationsItemsCount = createSelector([selectOrganizations], (organizations) => organizations.count);

export const selectOrganizationsItemsFilter = createSelector([selectOrganizations], (organizations) => organizations.filter);